import { CardapioDadosProps } from 'modulos/cardapio/containers/cardapio/cardapio-header/cardapio-header-props';
import { create } from 'zustand';

interface ICardapioDadosStore {
    cardapioDados: CardapioDadosProps | undefined
    setCardapioDados: (cardapioDados: CardapioDadosProps | undefined) => void
}

export const useCardapioDadosStore = create<ICardapioDadosStore>()((set) => ({
    cardapioDados: undefined,
    setCardapioDados: (cardapioDados: CardapioDadosProps | undefined) => set({ cardapioDados }),
}));